import * as React from 'react'

import { IChild } from 'main/gql/child'
import { NativeLink, palette, Strong, Text } from 'main/ui'
import { formatDateHuman } from 'main/util/date'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../../../common'
import { i18nKeyPrefix } from '../../../i18n'
import { Container } from './ChildCard.styles'
import Selector from './Selector'
import { SelectorType } from './types'

const PRE = `${i18nKeyPrefix}-BASE-CHILDREN-SELECTOR-CARD`

interface IProps {
  child: IChild
  selected: boolean
  selectorType: SelectorType
  onChangeSelected: (selected: boolean) => void
  onEdit: () => void
}

export default function Card(props: IProps) {
  const { child, selected, selectorType, onEdit, onChangeSelected } = props

  const { t } = useTranslation(LOCIZE_NAMESPACE)
  return (
    <Container selected={selected} onClick={() => onChangeSelected(!selected)}>
      <Selector selected={selected} type={selectorType} onChangeSelected={onChangeSelected} />

      <div css={{ flexGrow: 1 }}>
        <div>
          <Strong>
            {child.firstName}
            {child.lastName ? ` ${child.lastName[0]}.` : null}
          </Strong>
        </div>

        {child.desiredEnrollmentDate && (
          <div>
            <Strong css={{ color: palette.slate }}>{t(`${PRE}-DATE`)}</Strong>
            <Text css={{ color: palette.slate }}>
              {formatDateHuman(child.desiredEnrollmentDate)}
            </Text>
          </div>
        )}
      </div>

      <NativeLink
        onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
          // Stop event propagation to avoid it bubbling up to the outer container.
          event.stopPropagation()

          onEdit()
        }}
      >
        {t(`${PRE}-LINK`)}
      </NativeLink>
    </Container>
  )
}
